// assets/quantity-buttons.js

document.addEventListener('click', e => {
  const minus = e.target.closest('.qty-minus');
  const plus  = e.target.closest('.qty-plus');
  if (!minus && !plus) return;

  const wrapper = (minus || plus).closest('.qty-selector');
  const input   = wrapper.querySelector('.qty-field');
  const step    = parseInt(input.getAttribute('step')) || 1;
  const min     = parseInt(input.getAttribute('min'))  || 1;
  const maxAttr = input.getAttribute('max');
  const max     = maxAttr ? parseInt(maxAttr) : Infinity;
  const lineKey = input.getAttribute('data-line-key');
  let value     = parseInt(input.value) || 0;

  // Entfernen, wenn unter min
  if (minus && value <= min) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    })
    .then(() => {
      showCartStatus('Produkt wurde aus dem Warenkorb entfernt.');
      setTimeout(() => location.reload(), 1500);
    })
    .catch(() => showCartStatus('Fehler beim Entfernen des Produkts.', true));
    return;
  }

  // Ansonsten hoch/runter
  value += plus ? step : -step;
  value = Math.max(min, Math.min(max, value));
  if (value === parseInt(input.value)) return;

  input.value = value;
  input.dispatchEvent(new Event('input',  { bubbles: true }));
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

function showCartStatus(text, isError = false) {
  const statusEl = document.getElementById('cart-status');
  if (!statusEl) return;
  statusEl.textContent = text;
  statusEl.hidden = false;
  statusEl.classList.toggle('error', isError);
  setTimeout(() => statusEl.hidden = true, 3000);
}
